import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";

const AdminContext = createContext(null);

export function AdminAuthProvider({ children }) {
    const [admin, setAdmin] = useState(null); // null = checking, false = unauth, object = admin
    const [ready, setReady] = useState(false);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/admin/me");
            setAdmin(data);
            return data;
        } catch {
            setAdmin(false);
            return null;
        }
    }, []);

    useEffect(() => {
        (async () => {
            await refresh();
            setReady(true);
        })();
    }, [refresh]);

    const login = async (email, password) => {
        try {
            const { data } = await api.post("/admin/login", { email, password });
            setAdmin(data);
            return { ok: true, admin: data };
        } catch (e) {
            return {
                ok: false,
                error: formatApiErrorDetail(e.response?.data?.detail) || e.message,
            };
        }
    };

    const logout = async () => {
        try {
            await api.post("/admin/logout");
        } catch {
            /* ignore */
        }
        setAdmin(false);
    };

    return (
        <AdminContext.Provider value={{ admin, ready, login, logout, refresh }}>
            {children}
        </AdminContext.Provider>
    );
}

export const useAdminAuth = () => useContext(AdminContext);
